const MainContainer = ({ className = '', children }) => {
    return(
        <div className={className}>
            {children}
        </div>
    );
}

export default MainContainer;